var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable, makeObservable } from 'mobx';
import { getComparableVehicle } from '../framework/DataTransformers';
import i18next from 'i18next';
const t = (key, options) => i18next.t(key, options);
import UserActionsAPI from '../services/UserActionsAPI';
import NotificationStore from './NotificationStore';
import { VEHICLE_COMPARE_LIMIT } from '../framework/constants/cars';
import { ShowNotificationError } from '../framework/ErrorLogger';
class CompareStore {
    constructor() {
        // list of vehicles objects to compare
        Object.defineProperty(this, "vehiclesCompared", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // list of ids to receive vehicles objects
        Object.defineProperty(this, "vehiclesIDsToCompare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // flag that defines difference mode switched on/off
        Object.defineProperty(this, "isDiff", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // get list of compared vehicles objects
        Object.defineProperty(this, "getComparedVehicles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return Promise.all([
                    UserActionsAPI.getComparedVehicles(this.vehiclesIDsToCompare, false),
                    UserActionsAPI.getComparedVehicles(this.vehiclesIDsToCompare, true)
                ])
                    .then(([cars, carsDiff]) => {
                    this.vehiclesCompared = this.vehiclesIDsToCompare.map((carId) => {
                        const car = cars.find((obj) => obj._id === carId);
                        const carDiff = carsDiff.find((obj) => obj._id === carId);
                        return getComparableVehicle(car, carDiff);
                    });
                    return this.vehiclesCompared;
                })
                    .catch((error) => {
                    console.log('error', error);
                    ShowNotificationError('errors.loadCompare');
                });
            }
        });
        // remove particular vehicle from compared page
        Object.defineProperty(this, "removeVehicleFromCompare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vehicleID) => {
                const index = this.vehiclesIDsToCompare.indexOf(vehicleID);
                if (index !== -1)
                    this.vehiclesIDsToCompare.splice(index, 1);
            }
        });
        // select/deselect vehicle to compare
        Object.defineProperty(this, "toggleCarToCompare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => {
                const index = this.vehiclesIDsToCompare.indexOf(carId);
                if (index === -1) {
                    if (this.vehiclesIDsToCompare.length >= VEHICLE_COMPARE_LIMIT) {
                        NotificationStore.addNotification({
                            message: t('Notifications:errors.max10ToCompare'),
                            level: 'error'
                        });
                        return;
                    }
                    this.vehiclesIDsToCompare.push(carId);
                }
                else {
                    this.vehiclesIDsToCompare = [...this.vehiclesIDsToCompare.slice(0, index), ...this.vehiclesIDsToCompare.slice(index + 1, this.vehiclesIDsToCompare.length)];
                }
            }
        });
        // select all vehicles to compare
        Object.defineProperty(this, "toggleCheckAllCarsToCompare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cars) => {
                const newCarsToCompare = [];
                const isCheckAll = this.vehiclesIDsToCompare.length === cars.length || this.vehiclesIDsToCompare.length >= VEHICLE_COMPARE_LIMIT;
                if (!isCheckAll) {
                    if (cars.length <= VEHICLE_COMPARE_LIMIT) {
                        cars.map((car) => newCarsToCompare.push(car.id));
                    }
                    else {
                        cars.slice(0, VEHICLE_COMPARE_LIMIT).map((car) => newCarsToCompare.push(car.id));
                        NotificationStore.addNotification({
                            message: t('Notifications:errors.addedToComparison'),
                            level: 'warning'
                        });
                    }
                }
                return this.vehiclesIDsToCompare = newCarsToCompare;
            }
        });
        Object.defineProperty(this, "setDiffMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isDiff) => {
                this.isDiff = isDiff;
            }
        });
        Object.defineProperty(this, "removeVehicleIDFromCompare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vehicleID) => {
                this.vehiclesIDsToCompare = this.vehiclesIDsToCompare.filter((carID) => carID !== vehicleID);
            }
        });
        Object.defineProperty(this, "clearComparedVehicles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.vehiclesCompared = [];
            }
        });
        makeObservable(this);
    }
    get vehiclesComparedCount() {
        return this.vehiclesCompared.length;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], CompareStore.prototype, "vehiclesCompared", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], CompareStore.prototype, "vehiclesIDsToCompare", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], CompareStore.prototype, "isDiff", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CompareStore.prototype, "vehiclesComparedCount", null);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "getComparedVehicles", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "removeVehicleFromCompare", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "toggleCarToCompare", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "toggleCheckAllCarsToCompare", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "setDiffMode", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "removeVehicleIDFromCompare", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], CompareStore.prototype, "clearComparedVehicles", void 0);
export default new CompareStore();
